export default __webpack_public_path__ + "static/media/aboutus-5.b7ac556d.jpg";